import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill={props.fillPrimary}
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H43V32H0z"
            data-name="Rectangle 993"
            transform="translate(.106 .332)"></path>
        </clipPath>
        <clipPath id="clip-Def">
          <path d="M0 0H78V78H0z"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-Def)">
        <g data-name="Group 2750" transform="translate(4.482 14.668)">
          <g data-name="Group 2746">
            <g clipPath="url(#clip-path)" data-name="Mask Group 32" transform="translate(13.411)">
              <g
                fill={props.fillPrimary}
                data-name="Group 2741"
                transform="rotate(-13 35.985 33.4)">
                <circle
                  cx="4.802"
                  cy="4.802"
                  r="4.802"
                  data-name="Ellipse 468"
                  transform="translate(26.277)"></circle>
                <path
                  d="M33.965 9.656s-.475 1.076-2.426.475-12.782-4.7-12.782-4.7l-.838.465c-.729-1.4-1.394-2.6-1.476-2.751a2.176 2.176 0 00-2.882-.716c-1.322.819-.792 2.575-.468 3.285.316.693 1.416 2.46 1.416 2.46l-6.257 3.783 9.379 7.428 7.8 13.845s1.089 2.326-.825 3.377-3.339-.75-3.64-1.014S13.5 23.475 13.5 23.475L2.249 14.621S-.977 12.5.3 9.481C1.339 7.01 10.8 1 10.8 1s2.768-2.253 7.225 0C20.9 2.455 33.164 7.455 33.164 7.455s1.551.825.801 2.201z"
                  data-name="Path 5669"
                  transform="translate(10.535 8.936)"></path>
                <path
                  d="M4.558 3.584l-2.947 1.83-1.37-2.391S-.568.859.778.184a2.021 2.021 0 012.551.993c.047.147.579 1.185 1.229 2.407z"
                  data-name="Path 5670"
                  transform="translate(23.628 11.473)"></path>
                <path
                  d="M15.083 11.673c-1.062.047-9.777-.567-9.777-.567L1.721 5.435S.644 3.668.351 3.044C.044 2.39-.457.88.889.205a1.927 1.927 0 012.55.995c.075.135.579 1.185 1.229 2.407a599.443 599.443 0 002.385 4.43l8.266.355a1.725 1.725 0 011.371 1.557c.094 1.322-.543 1.677-1.607 1.724z"
                  data-name="Path 5671"
                  transform="translate(23.518 11.452)"></path>
                <path
                  d="M11.576 0l6.641 5.337s.15 6.012 0 6.458-.9 1.159-2.514 1.534-12.794 2.326-12.794 2.326A2.477 2.477 0 01.02 13.367 2.534 2.534 0 012.159 10.4L12.4 8.264z"
                  data-name="Path 5672"
                  transform="translate(0 23.229)"></path>
              </g>
            </g>
            <g data-name="Group 2743" transform="translate(13.411 34.273)">
              <rect
                width="43"
                height="16"
                fill={props.fillPrimary}
                data-name="Rectangle 918"
                rx="8"
                transform="translate(.106 .059)"></rect>
              <text
                fill={props.fillSecondary}
                data-name="DEF"
                fontFamily="ProximaNova-Bold, Proxima Nova"
                fontSize="15"
                fontWeight="700"
                transform="translate(22.106 13.059)">
                <tspan x="-14.04" y="0">
                  DEF
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
